import { render, staticRenderFns } from "./HorseTemperature.vue?vue&type=template&id=4be725dc&"
import script from "./HorseTemperature.vue?vue&type=script&lang=js&"
export * from "./HorseTemperature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports